import React from "react";
import { Flex, SkeletonCircle } from "@chakra-ui/react";
import TabButton from "components/RFQ/TabButton/TabButton"; // 경로 확인 필요
import SkeletonBase from "newui/components/Skeleton"; // 경로 확인 필요
import { validStepChecker, isQuoteFormInvalid } from "../createRFQUtils"; // 경로 확인 필요

export const RFQTabNavigation = ({
	isLoading,
	tabButtonList,
	selectedTab,
	completedSteps,
	touchedTabs,
	formikRef,
	isTemplate,
	isEdit,
	rfqData,
	onChangeTab,
}) => {
	if (isLoading) {
		return (
			<div className="mb-2 flex w-full gap-4">
				{tabButtonList?.map((_, index) => (
					<div
						key={index}
						className="w-full space-y-4"
					>
						<SkeletonBase
							height="8px"
							className="!w-full"
						/>
						<Flex className="items-center gap-3">
							<SkeletonCircle startColor="lightgray" />
							<SkeletonBase />
						</Flex>
					</div>
				))}
			</div>
		);
	}

	return (
		<div
			id="tab-button-rfq"
			className="mb-2 flex gap-4"
		>
			{tabButtonList?.map((tab, index) => {
				const currentErrors = formikRef.current?.errors ?? {};
				const currentValues = formikRef.current?.values ?? {};

				const isStepGenerallyInvalid = !validStepChecker(
					tab.value,
					currentErrors,
					isTemplate
				).isValid;

				const isInitiallyInvalidTemplateQuoteOnLoad =
					isTemplate &&
					!isEdit &&
					!rfqData &&
					selectedTab === 1 &&
					tab.value === 4 &&
					currentValues.quote_type === "form" &&
					!touchedTabs.includes(tab.value) &&
					isQuoteFormInvalid(currentValues.quote);

				const showError =
					(isStepGenerallyInvalid && touchedTabs.includes(tab.value)) ||
					isInitiallyInvalidTemplateQuoteOnLoad;

				const showFinished =
					completedSteps.includes(tab.value) &&
					!isStepGenerallyInvalid &&
					!isInitiallyInvalidTemplateQuoteOnLoad;

				return (
					<TabButton
						key={index}
						{...tab}
						selectedTab={selectedTab}
						isActive={tab.value === selectedTab}
						onClick={() => onChangeTab(tab)}
						isFinished={showFinished}
						isError={showError}
					/>
				);
			})}
		</div>
	);
};
